import { render, staticRenderFns } from "./FrameCheckTabellaTest.vue?vue&type=template&id=3454993e&scoped=true&"
import script from "./FrameCheckTabellaTest.vue?vue&type=script&lang=js&"
export * from "./FrameCheckTabellaTest.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3454993e",
  null
  
)

export default component.exports